// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2o0Bk","header":"MergedInvoice_header__1KY0c"};